import { useEffect } from 'react';
//import { useSearchParams } from 'react-router-dom';
import RouteErrorPage from './RouteErrorPage';
// import useMediaQuery from './hooks/useMediaQuery';
// import GlobalData, { GlobalDataContext } from './GlobalData'
import Router from './Router';
import Theme from './Theme';
import Main from './Main/Main';
import Jobs from './Main/Jobs/Jobs';
import AwsJobs from './Main/AwsJobs/AwsJobs';
import MongoJobs from './Main/MongoJobs/MongoJobs';
import Apps from './Main/Apps/Apps';
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import AdminImitatorLogin from './AdminImitatorLogin';
import { GlobalDataProvider } from './GlobalData';
import GlobalStyle from './GlobalStyle';
import '@prosolve/common-components-ui/dist/styles.css'
import { rootPrefix } from './utils/utils';

// import consoleOverride from './consoleOverride';
// Unneeded for now...but can put override back in if we use a library that clutters up the console with logs
// consoleOverride();

// Used to wrap route and override title seen in the browser Tab --
const Page = ({ title, children }) => {

  useEffect(() => {
    document.title = title || "";
  }, [title]);

  return (
    <Theme>
      <GlobalStyle />
      <GlobalDataProvider>
        <>{children}</>
      </GlobalDataProvider>
    </Theme>
  );
};

export default () => {
  // const isMobileView = useMediaQuery('(max-width: 450px)');

  // const globalData = new GlobalData();
  // globalData.setIsMobileView(isMobileView)

  const routes = [
    {
      path: rootPrefix,
      isPrivate: true,
      element: (routeProps) => (
        <Page title='ProSolve Job Portal'>
          <Main {...routeProps} />
        </Page>
      ),
      children: [
        {
          path: "",
          element: <AwsJobs />
        },
        {
          path: "jobs",
          element: <Jobs />
        },
        {
          path: "awsJobs",
          element: <AwsJobs />
        },
        {
          path: "mongoJobs",
          element: <MongoJobs />
        },
        {
          path: "Apps/:app",
          element: <Apps />
        },
      ],
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: `${rootPrefix}/adminImitatorLogin`,
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <AdminImitatorLogin {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: `${rootPrefix}/healthcheck`,
      element: (routeProps) => (
        <div>Ok</div>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: `${rootPrefix}/forgotpassword`,
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ForgotPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: `${rootPrefix}/resetPassword`,
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ResetPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
  ]

  return (
    <Router routes={routes} />
  );
}
